export function GetCleanText(text: string) {
    text = GetTextWithoutQuotes(text);
    text = GetTextWithoutLineBreaks(text);
    text = GetTextWithoutExcerptNotes(text);

    return text;
}

function GetTextWithoutQuotes(text: string): string {
    return text.replace(/[“”"]/g, "");
}


function GetTextWithoutLineBreaks(text: string) {
    return text.replace(/(\r\n|\n|\r)/gm, " ");
}

function GetTextWithoutExcerptNotes(text: string): string {
    const index = text.toLowerCase().indexOf("excerpt from");
    const result = index !== -1 ? text.substring(0, index).trim() : text;
    return result;
}
